import React from 'react';
import SMReservationBaseView from './SMReservationBaseView';
import SMReservationCalendarDesktopView from './SMReservationCalendarDesktopView';
import SMStayReservationCalendarDesktopView from './SMStayReservationCalendarDesktopView';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMPlanHelper from 'components/helpers/SMPlanHelper';
import SMConst from 'lib/SMConst';
import sprintf from 'sprintf';
import SMUserContactView from 'components/users/SMUserContactView';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationDesktopView extends SMReservationBaseView {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    $(this.refs.spaceSide).sticky({
      topSpacing:32,
      bottomSpacing:$("#js-site-footer").outerHeight() + 24
    });

    this.subscribeOptionSelectEvent();
    this.subscribeGuestsSelectEvent();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.plan && this.state.isHourly != null) {
      this.subscribeOptionSelectEvent();
    }
    if (this.state.plan && this.state.isHourly != null) {
      this.subscribeGuestsSelectEvent();
    }

  }

  planDidSelect(index, e) {
    super.planDidSelect(index, e);

    setTimeout(()=>{
      $("body").animate({scrollTop: $(this.refs.priceTypeContainer).offset().top}, 500);
    }, 500);
  }

  priceTypeDidSelect(e) {
    super.priceTypeDidSelect(e);
    setTimeout(()=>{
      $("body").animate({scrollTop: $(this.refs.scheduleContainer).offset().top}, 500);
    }, 500);
  }

  renderPlans(room) {
    let rows = [];
    let roomPlans = [this.state.room].concat(room.plans);

    roomPlans.forEach((plan, index)=>{
      const name = plan.plan_name || plan.name;
      const description = (index == 0) ? plan.plan_description : plan.description;
      const id = sprintf("plan-radio__%s", plan.id);

      let prices = [];
      if (plan.has_session_price) {
        prices.push(
          <div key="session_price" className="reserve-plan__price-number">{plan.session_price_text}<span className="reserve-plan__price-utility">/{plan.session_price_unit_text}〜</span></div>
        );
      }
      if (plan.has_hourly_price) {
        prices.push(
          <div key="hourly_price" className="reserve-plan__price-number">{plan.hourly_price_text}<span className="reserve-plan__price-utility">/{plan.hourly_price_unit_text}〜</span></div>
        );
      }
      if (plan.has_daily_price) {
        prices.push(
          <div key="daily_price" className="reserve-plan__price-number">{plan.daily_price_text}<span className="reserve-plan__price-utility">/{plan.daily_price_unit_text}〜</span></div>
        );
      }
      if (plan.has_stay_price) {
        prices.push(
          <div key="stay_price" className="reserve-plan__price-number">{plan.stay_price_text}<span className="reserve-plan__price-utility">/{plan.stay_price_unit_text}〜</span></div>
        );
      }

      const isChecked = this.state.plan && plan.id == this.state.plan.id;

      rows.push(
        <div key={plan.id} onChange={(e) => this.planDidSelect(index, e)}
             className="reserve-card__inner reserve-plan__content clearfix">
          <div className="reserve-plan__price">
            {prices}
          </div>
          <div className="reserve-plan__name">
            <input type="radio" defaultChecked={isChecked} value={plan.id} id={id} name="plan_id" />
            <label htmlFor={id} className="service-radio"><span className="reserve-plan__title">{name}</span>
              {SMRenderHelper.renderDirectReservationIcon(plan)}
              {SMRenderHelper.renderLastMinuteDiscountIcon(plan)}
              {SMRenderHelper.renderMinRequiredDateOrTime(plan, "reserve-plan__period")}
              {SMRenderHelper.renderHasRequiredFood(plan, "reserve-plan__period")}
            </label>
          </div>
          <div className="reserve-plan__notes">
            <p className="reserve-plan__notes-text">{description}</p>
          </div>
        </div>
      );
    });
    return rows;
  }

  renderPriceType(room) {
    const plan = this.state.plan;
    const planId = SMPlanHelper.isRoom(plan) ? 0 : plan.id;
    let rows = [];
    if (plan.has_stay_price) {
      const id = sprintf("reserve-type__radio--stay-%s", planId);
      rows.push(
        <p key={id} className="reserve-type__button">
          <input onChange={(e) => this.priceTypeDidSelect(e)} checked={true} id={id} type="radio" name="is_hourly" value={0} className="reserve-type__button-radio" />
          <label htmlFor={id} className="reserve-type__button-label">{I18n.t("service.label_000400")}<span className="reserve-type__price">{plan.stay_price_text}/{plan.stay_price_unit_text}〜</span></label>
        </p>
      );
    } else if (plan.has_session_price) {
      const id = sprintf("reserve-type__radio--session-%s", planId);
      const isHourly = plan.min_required_session_hour_unit == SMConst.RequiredUnit.Hour ? 1 : 0;

      rows.push(
        <p key={id} className="reserve-type__button">
          <input onChange={(e) => this.priceTypeDidSelect(e)} checked={true} id={id} type="radio" name="is_hourly" value={isHourly} className="reserve-type__button-radio" />
          <label htmlFor={id} className="reserve-type__button-label">回ごと価格<span className="reserve-type__price">{plan.session_price_text}/{plan.session_price_unit_text}〜</span></label>
        </p>
      );
    } else {
      if (plan.has_hourly_price) {
        const id = sprintf("reserve-type__radio--hourly-%s", planId);
        rows.push(
          <p key={id} className="reserve-type__button">
            <input onChange={(e) => this.priceTypeDidSelect(e)} checked={this.state.isHourly == true} id={id} type="radio" name="is_hourly" value={1} className="reserve-type__button-radio" />
            <label htmlFor={id} className="reserve-type__button-label">時間価格<span className="reserve-type__price">{plan.hourly_price_text}/{plan.hourly_price_unit_text}〜</span></label>
          </p>
        );
      }
      if (plan.has_daily_price) {
        const id = sprintf("reserve-type__radio--daily-%s", planId);
        rows.push(
          <p key={id} className="reserve-type__button">
            <input onChange={(e) => this.priceTypeDidSelect(e)} checked={this.state.isHourly == false} id={id} type="radio" name="is_hourly" value={0} className="reserve-type__button-radio" />
            <label htmlFor={id} className="reserve-type__button-label">1日価格<span className="reserve-type__price">{plan.daily_price_text}/{plan.daily_price_unit_text}〜</span></label>
          </p>
        );
      }
    }
    return(
      <div ref="priceTypeContainer" key="price_type" className="reserve-next">
        <fieldset>
          <legend className="reserve-subtitle">利用タイプを選択</legend>
          <div className="reserve-card sm-hide__guteter">
            <div className="reserve-card__inner reserve-type clearfix">
              {rows}
            </div>
          </div>
          <input type="hidden" name="rent_type" value={this.state.rentType} />
        </fieldset>
      </div>
    );
  }

  renderCheckinAt() {
    let checkinAtDate = new Date(this.requestParams.reserved_schedules[0]["started_at"]);
    let checkinStartHour = this.state.checkinEnable;

    let checkinEndHour =  this.state.plan.has_extra_stay_checkinout_hour ?
      this.state.plan.extra_stay_checkin_end_hour : this.props.room.stay_checkin_end_hour;

    let checkinAtRows = [];
    let checkinDefault = checkinStartHour.toString() + ":00";
    if (this.state.validatedReservation && this.state.validatedReservation.checkin_time) {
      checkinDefault = this.state.validatedReservation.checkin_time;
    }
    for (let i = checkinStartHour; i <= checkinEndHour; i++) {
      let hour = i;
      let checkinTimeZero = i.toString() + ":00";
      let checkinTimeHalf = i.toString() + ":30";
      if (i == checkinStartHour) {
        checkinAtRows.push(<option key={checkinTimeZero} value={checkinTimeZero}>{checkinTimeZero}</option>);
        checkinAtRows.push(<option key={checkinTimeHalf} value={checkinTimeHalf}>{checkinTimeHalf}</option>);
      } else {
        checkinAtRows.push(<option key={checkinTimeZero} value={checkinTimeZero}>{checkinTimeZero}</option>);
        if (i == checkinEndHour) {
          break;
        } else {
          checkinAtRows.push(<option key={checkinTimeHalf} value={checkinTimeHalf}>{checkinTimeHalf}</option>);
        }
      }
    }

    return (
      <div className="reserve-stay__line-inner">
        <label>
          <span className="reserve-stay__line-inner-title">チェックイン時刻</span>
          <span className="reserve-stay__line-inner-form">
            <span className="service-select">
              <select onChange={this.checkinAtDidSelect} name="checkin_at" id="checkin_at" className="service-select__purpose w110" defaultValue={checkinDefault}>
                {checkinAtRows}
              </select>
            </span>
         </span>
        </label>
        <span className="reserve-stay__checkin-time">チェックイン可能時刻：{checkinStartHour.toString() + ":00～" + checkinEndHour.toString() + ":00"}</span>
      </div>
    );
  }

  renderSelectSchedules(room) {
    return(
      <div ref="scheduleContainer" key="schedules" className="reserve-next">
        <fieldset>
          <legend className="reserve-subtitle">利用期間</legend>
          {(()=>{
            if (this.isStayPlan()) {
              return (
                <SMStayReservationCalendarDesktopView
                  delegate={this}
                  room={room}
                  reservation={this.requestParams}
                  plan={this.state.plan}
                  isHourly={this.state.isHourly}
                  calendarState={this.state.calendarState}
                />
              );
            } else {
              return (
                <SMReservationCalendarDesktopView
                  delegate={this}
                  room={room}
                  reservation={this.requestParams}
                  plan={this.state.plan}
                  isHourly={this.state.isHourly}
                  calendarState={this.state.calendarState}
                />
              );
            }
          })()}
        </fieldset>
      </div>
    );
  }

  renderNumberOfGuests() {
    const stayCapacity = this.isStayPlan() ? this.props.room.stay_capacity : this.props.room.capacity;
    let optionRows = [];
    let priceText = "";
    if (this.isStayPlan()) {
      priceText = this.state.plan.stay_price_text;
    } else if (this.state.plan.has_session_price) {
      priceText = this.state.plan.session_price_text;
    } else {
      if (this.state.isHourly == "1") {
        priceText = this.state.plan.hourly_price_text;
      } else {
        priceText = this.state.plan.daily_price_text;
      }
    }
    let perPersonLabel = this.isPerPersonPlan() ?
      <span className="reserve-stay__checkin-time">利用人数ごとに料金が加算されます ({priceText}/人)</span> : "";

    for (let i = 1; i <= stayCapacity; i++) {
      let value = i;
      if (i == 1) {
        optionRows.push(<option value={value} defaultValue={value} selected>{i}</option>);
      } else {
        optionRows.push(<option value={value}>{i}</option>);
      }
    }
    let numberOfPeople = 1;
    if (this.state.validatedReservation && this.state.validatedReservation.number_of_guests) {
      numberOfPeople = this.state.validatedReservation.number_of_guests;
    }

    return (
      <div className="reserve-stay__line-inner">
        <span className="reserve-stay__line-inner-title">利用人数</span>
        <div className="reserve-option__number">
          <input className="js-reserve__spinner_guests" name="value" defaultValue={numberOfPeople} readOnly="readonly" />
        </div>
        {perPersonLabel}
      </div>
    );
  }

  renderStayGuestInfo() {
    return (
      <div key="stay_guest_info" className="reserve-next">
        <fieldset>
          <legend className="reserve-subtitle">宿泊者情報</legend>
          <div className="reserve-card sm-hide__guteter">
            <div className="reserve-card__inner clearfix">
              <div className="reserve-stay__line">
                {this.renderNumberOfGuests()}
                {this.renderCheckinAt()}
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    );
  }

  renderGuestInfo() {
    return (
      <div key="guest_info" className="reserve-next">
        <fieldset>
          <legend className="reserve-subtitle">ゲスト情報</legend>
          <div className="reserve-card sm-hide__guteter">
            <div className="reserve-card__inner clearfix">
              <div className="reserve-stay__line">
                {this.renderNumberOfGuests()}
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    );
  }

  renderSelectOptions(room) {
    return(
      <div key="options" className="reserve-next">
        <fieldset>
          <legend className="reserve-subtitle">追加料金（オプション）</legend>
          <div className="reserve-card sm-hide__guteter">
            <h2 style={SMRenderHelper.hideIfEmpty(room.option_items)} className="reserve-option__headline">設備・サービス</h2>
            {this.renderOptionItems(room)}
            <h2 style={SMRenderHelper.hideIfEmpty(room.option_foods)} className="reserve-option__headline">飲食</h2>
            {this.renderOptionFoods(room)}
          </div>
        </fieldset>
      </div>
    );
  }

  renderOptionFoods(room) {
    let rows = [];
    room.option_foods.forEach((item, index)=>{
      const id = sprintf("reserve-option-food__checkbox%s", item.id);
      const style = !item.countable || item.max_count < 2 ? {display: "none"} : {};
      const defaultChecked = item.defaultChecked ? true : false;
      const defaultNumber = item.number ? item.number : 1;
      rows.push(
        <div key={item.id} className="reserve-card__inner clearfix">
          <div className="reserve-option__content">
            <div style={style} className="reserve-option__number">
              <input data-option-type="food" data-index={index} className="js-reserve__spinner" id={id + "__number"} name="value" defaultValue={defaultNumber} readOnly="readonly" />
            </div>
            <div className="reserve-option__content-headline">
              <input onChange={(e) => this.optionFoodDidSelect(index, e)} type="checkbox" id={id} name="reserve-option__service" defaultChecked={defaultChecked} />
              <label htmlFor={id} className="service-checkbox">
                <span className="reserve-option__name">{item.name}</span><span className="reserve-option__price">{item.price_text}<span className="reserve-option__price-number">/{item.price_unit_text}</span></span>
              </label>
            </div>
            <div className="reserve-option__content-notes">
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      );
    });
    return rows;
  }

  renderOptionItems(room) {
    let rows = [];
    room.option_items.forEach((item, index)=>{
      const id = sprintf("reserve-option-item__checkbox-%s", item.id);
      const style = !item.countable || item.max_count < 2 ? {display: "none"} : {};
      const defaultChecked = item.defaultChecked ? true : false;
      const defaultNumber = item.number ? item.number : 1;
      rows.push(
        <div key={item.id} className="reserve-card__inner clearfix">
          <div className="reserve-option__content">
            <div style={style} className="reserve-option__number">
              <input data-option-type="item" data-index={index} className="js-reserve__spinner" id={id + "__number"} name="number" defaultValue={defaultNumber} readOnly="readonly" />
            </div>
            <div className="reserve-option__content-headline">
              <input onChange={(e) => this.optionItemDidSelect(index, e)} type="checkbox" id={id} defaultChecked={defaultChecked} />
              <label htmlFor={id} className="service-checkbox">
                <span className="reserve-option__name">{item.name}</span><span className="reserve-option__price">{item.price_text}<span className="reserve-option__price-number">/{item.price_unit_text}</span></span>
              </label>
            </div>
            <div className="reserve-option__content-notes">
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      );
    });
    return rows;
  }

  renderSideBar(room) {
    let inner = null;

    let noLoginDisplay = null;
    if (!this.props.currentUser) {
      noLoginDisplay = (
        <p className="reserve-situation__login">予約するにはログインが必要です。</p>
      );
    }

    if (this.state.validatedReservation) {
      let buttonClassName = "button-blue pt15 pb15 fz16 w100pa";
      if (!this.state.isValid) {
        buttonClassName += " button-disabled";
      }
      if (this.isStayPlan()) {
        inner = (
          <div className="site-sidebar__inner">
            <dl className="reserve-situation">
              <dt>利用期間</dt>
              <dd>{this.state.validatedReservation.checkin_date}〜<br />{this.state.validatedReservation.checkout_date}</dd>
              <dt>時刻</dt>
              <dd>
                <div className="reserve-situation__check">
                  <span className="reserve-situation__check-text">チェックイン</span>
                  <span className="reserve-situation__check-time">{this.state.validatedReservation.checkin_time}</span>
                </div>
                <div className="reserve-situation__check">
                  <span className="reserve-situation__check-text">チェックアウト</span>
                  <span className="reserve-situation__check-time">{this.state.validatedReservation.checkout_time}</span>
                </div>
              </dd>
              <dt>利用人数</dt>
              <dd>{this.requestParams.number_of_guests}人</dd>
              <dt className="request-breakdown__detail-help">サービス料<span className="request-breakdown__help"><i className="fa fa-question-circle"></i><span className="mod-tooltip request-breakdown__help-tooltip"><span className="baloon baloon-top user-detail-baloon mod-tooltip__detail request-breakdown__help-baloon"><span className="baloon-inner">ゲスト様が利用時に支払うサービスの維持管理費となります</span></span></span></span>
              </dt>
              <dd>{this.state.validatedReservation.billing.guest_fee_amount_text}</dd>
              <dt>合計</dt>
              <dd>{this.state.priceText}<br />{this.state.priceExtraText}</dd>
            </dl>
            {this.renderRequiredDescriptions()}
            <a onClick={(e) => this.showRequestView(e)} className="button-blue pt15 pb15 fz16 w100pa">予約リクエストへ進む</a>
            {noLoginDisplay}
          </div>
        );
      } else {
        inner = (
          <div className="js-reservation-submit-card site-sidebar__inner">
            <dl className="reserve-situation">
              <dt>利用期間</dt>
              <dd>{this.state.reservedDateText}</dd>
              <dt className="request-breakdown__detail-help">サービス料<span className="request-breakdown__help"><i className="fa fa-question-circle"></i><span className="mod-tooltip request-breakdown__help-tooltip"><span className="baloon baloon-top user-detail-baloon mod-tooltip__detail request-breakdown__help-baloon"><span className="baloon-inner">ゲスト様が利用時に支払うサービスの維持管理費となります</span></span></span></span></dt>
              <dd>{this.state.validatedReservation.billing.guest_fee_amount_text}</dd>
              <dt>合計</dt>
              <dd>{this.state.priceText}<br />{this.state.priceExtraText}</dd>
            </dl>
            {this.renderRequiredDescriptions()}
            <a onClick={(e) => this.showRequestView(e)} className={buttonClassName}>予約リクエストへ進む</a>
            {noLoginDisplay}
          </div>
        );
      }
    } else {
      inner = (
        <div className="js-reservation-submit-card site-sidebar__inner">
          <dl className="reserve-situation">
            <dt>利用期間</dt>
            <dd>利用期間を選択して下さい</dd>
          </dl>
          {this.renderRequiredDescriptions()}
          <a className="button-disabled button-blue pt15 pb15 fz16 w100pa">予約リクエストへ進む</a>
          {noLoginDisplay}
        </div>
      );
    }
    return(
      <div className="col-sm-12 col-md-4 sm-hide side-fixed">
        <div ref="spaceSide" className="space-side">
          <div className="site-sidebar">
            <h2 className="site-sidebar__headline">選択中のスペース</h2>
            <a href={Routes.space_room_path(room.space.username, room.uid)}>
              <div className="reserve-sidebar__space clearfix">
                <div className="reserve-sidebar__space-img">
                  <img src={SMFormatHelper.roomImageURL(room, {width: 490, height: 490})} alt={SMFormatHelper.roomName(room)} />
                </div>
                <div className="reserve-sidebar__space-text">
                  <h3 className="reserve-sidebar__space-title">{SMFormatHelper.roomName(room)}</h3>
                </div>
              </div>
            </a>
            <h2 className="site-sidebar__headline">現在の入力状況</h2>
            {inner}
          </div>
        </div>
      </div>
    );
  }

  renderRequiredDescriptions() {
    let rows = [];
    const ScheduleType = {
      Disable: 1,
      Reservation: 10,
      Imported: 20,
    };

    if (this.state.validatedReservation && this.state.validatedReservation.is_last_minute_discount_warning) {
      rows.push(
        <p key="last_minute_discount" className="reserve-situation__required"><i className="fa fa-exclamation-circle"></i>直前割期間対象外の利用期間が存在するため、直前割は適用されません。</p>
      );
    }

    if (this.state.isValid) return rows;
    if (this.state.errors && this.state.errors.length > 0) {
      this.state.errors.forEach((error, index)=>{
        rows.push(
          <p key={index} className="reserve-situation__required"><i className="fa fa-exclamation-circle"></i>{error.message}</p>
        );
      });
    } else {
      if (this.state.plan) {
        if (SMPlanHelper.shoudRenderMinRequiredDate(this.state.plan) && this.state.isHourly == 0) {
          rows.push(
            <p key="min_hour" className="reserve-situation__required"><i className="fa fa-exclamation-circle"></i>最低利用日数は<strong>{this.state.plan.min_required_hour}日間</strong>です。</p>
          );
        } else if (SMPlanHelper.shouldRenderMinRequiredTime(this.state.plan) && this.state.isHourly == 1) {
          rows.push(
            <p key="min_hour" className="reserve-situation__required"><i className="fa fa-exclamation-circle"></i>最低利用時間は<strong>{this.state.plan.min_required_hour}時間</strong>です。</p>
          );
        }
        if (SMPlanHelper.shouldRenderRequiredFood(this.state.plan)) {
          rows.push(
            <p key="food" className="reserve-situation__required"><i className="fa fa-exclamation-circle"></i>このプランは飲食が<strong>必須</strong>です。</p>
          );
        }
      }
      if (this.state.validatedReservation && !this.state.validatedReservation.is_available) {
        let schedule_types = [];
        this.state.validatedReservation.reserved_schedules.forEach(function(value) {
          schedule_types.push(value.schedule_type);
        });
        if (schedule_types.indexOf(ScheduleType.Disable) >= 0 || schedule_types.indexOf(ScheduleType.Imported) >= 0) {
          rows.push(
            <p key="disable" className="reserve-situation__required"><i className="fa fa-exclamation-circle"></i>{I18n.t("service.text_000005")}</p>
          );
        }
        if (schedule_types.indexOf(ScheduleType.Reservation) >= 0) {
          rows.push(
            <p key="reservation" className="reserve-situation__required"><i className="fa fa-exclamation-circle"></i>{I18n.t("service.text_000006")}</p>
          );
        }
      }
    }
    return rows;
  }

  renderEstimateLink() {
    const query = window.btoa(JSON.stringify(this.requestParams));
    const estimateUrl = `${this.props.roomPath}/estimate?query=${query}`;

    return(
      <p className="reserve-payment__notes-text">見積書の発行は<a href={estimateUrl} className="a__underline" target="_blank">こちら</a>。印刷、またはPDFに保存してお使いいただけます。</p>
    );
  }

  renderResult(room) {
    let mobileRows = [];
    if (!this.state.isValid) {
      if (this.state.errors && this.state.errors.length > 0) {
        this.state.errors.forEach((error, index)=>{
          mobileRows.push(
            <p key={index} className="reserve-payment__notify-info-time"><i className="fa fa-exclamation-circle"></i>{error.message}</p>
          );
        });
      } else {
        if (!this.state.plan) {
          mobileRows.push(
            <p key="info" className="reserve-payment__notify-info-time">プランを選択してください</p>
          );
        } else {
          if (!this.state.validatedReservation) {
            mobileRows.push(
              <p key="info" className="reserve-payment__notify-info-time">利用期間を選択してください</p>
            );
          }
          if (SMPlanHelper.shoudRenderMinRequiredDate(this.state.plan)) {
            mobileRows.push(
              <p key="min_hour" className="reserve-payment__notify-info-time">最低利用日数は<strong>{this.state.plan.min_required_hour}日間</strong>です。</p>
            );
          } else if (SMPlanHelper.shouldRenderMinRequiredTime(this.state.plan)) {
            mobileRows.push(
              <p key="min_hour" className="reserve-payment__notify-info-time">最低利用時間は<strong>{this.state.plan.min_required_hour}時間</strong>です。</p>
            );
          }
          if (SMPlanHelper.shouldRenderRequiredFood(this.state.plan)) {
            mobileRows.push(
              <p key="food" className="reserve-payment__notify-info-time">このプランは飲食が<strong>必須</strong>です。</p>
            );
          }
        }
      }
    }
    if (this.state.priceText) {
      mobileRows.push(
        <p key="price" className="reserve-payment__notify-info-payment">{this.state.priceText} {this.state.priceExtraText}</p>
      );
    }

    let noLoginDisplay = null;
    if (!this.props.currentUser) {
      noLoginDisplay = (
        <p className="reserve-payment__notify-login">予約するにはログインが必要です。</p>
      );
    }
    const buttonLabel = "予約リクエストへ進む";

    let inner = null;
    if (this.state.validatedReservation) {
      let buttonClassName = "button-blue reserve-payment__notify-button";
      if (!this.state.isValid) {
        buttonClassName += " button-disabled";
      }
      if (this.isStayPlan()) {
        inner = (
          <dl className="reserve-situation reserve-payment__main">
            <dt>利用期間</dt>
            <dd>{this.state.validatedReservation.checkin_date}〜{this.state.validatedReservation.checkout_date}</dd>
            <dt>時刻</dt>
            <dd>
              <div className="reserve-situation__check">
                <span className="reserve-situation__check-text">チェックイン</span>
                <span className="reserve-situation__check-time">{this.state.validatedReservation.checkin_time}</span>
              </div>
              <div className="reserve-situation__check">
                <span className="reserve-situation__check-text">チェックアウト</span>
                <span className="reserve-situation__check-time">{this.state.validatedReservation.checkout_time}</span>
              </div>
            </dd>
            <dt>利用人数</dt>
            <dd>{this.requestParams.number_of_guests}人</dd>
            <dt className="request-breakdown__detail-help">サービス料<span className="request-breakdown__help"><i className="fa fa-question-circle"></i><span className="mod-tooltip request-breakdown__help-tooltip"><span className="baloon baloon-top user-detail-baloon mod-tooltip__detail request-breakdown__help-baloon"><span className="baloon-inner">ゲスト様が利用時に支払うサービスの維持管理費となります</span></span></span></span></dt>
            <dd>{this.state.validatedReservation.billing.guest_fee_amount_text}</dd>
            <dt>合計</dt>
            <dd>
              <div className="reserve-payment__price">{this.state.priceText}<br /><span className="reserve-payment__price-all">{this.state.priceExtraText}</span></div>
              <div className="reserve-payment__notify">
                <div className="pc-hide__sm-show reserve-payment__notify-info">
                  {mobileRows}
                </div>
                <a onClick={(e) => this.showRequestView(e)} className={buttonClassName}>{buttonLabel}</a>
                {noLoginDisplay}
              </div>
            </dd>
          </dl>
        );
      } else {
        inner = (
          <dl className="reserve-situation reserve-payment__main">
            <dt>利用期間</dt>
            <dd>{this.state.reservedDateText}</dd>
            <dt className="request-breakdown__detail-help">サービス料<span className="request-breakdown__help"><i className="fa fa-question-circle"></i><span className="mod-tooltip request-breakdown__help-tooltip"><span className="baloon baloon-top user-detail-baloon mod-tooltip__detail request-breakdown__help-baloon"><span className="baloon-inner">ゲスト様が利用時に支払うサービスの維持管理費となります</span></span></span></span></dt>
            <dd>{this.state.validatedReservation.billing.guest_fee_amount_text}</dd>
            <dt>合計</dt>
            <dd>
              <div className="reserve-payment__price">{this.state.priceText}<br /><span className="reserve-payment__price-all">{this.state.priceExtraText}</span></div>
              <div className="reserve-payment__notify">
                <div className="pc-hide__sm-show sm-reserve__footer">
                  <div className="reserve-payment__notify-info">
                    {mobileRows}
                  </div>
                </div>
                <a onClick={(e) => this.showRequestView(e)} className={buttonClassName}>{buttonLabel}</a>
                {noLoginDisplay}
              </div>
            </dd>
          </dl>
        );
      }
    } else {
      inner = (
        <dl className="reserve-situation reserve-payment__main">
          <dt>利用期間</dt>
          <dd className="reserve-payment__disable">
            <div className="reserve-payment__disable-text">利用期間を選択してください</div>
            <div className="reserve-payment__price">{this.state.priceText}<br /><span className="reserve-payment__price-all">{this.state.priceExtraText}</span></div>
            <div className="reserve-payment__notify">
              <div className="pc-hide__sm-show sm-reserve__footer">
                <div className="reserve-payment__notify-info">
                  {mobileRows}
                </div>
              </div>
              <a className="button-disabled button-blue reserve-payment__notify-button">{buttonLabel}</a>
              {noLoginDisplay}
            </div>
          </dd>
        </dl>
      );
    }

    return(
      <div key="result" className="reserve-next">
        <div className="js-reservation-submit-card reserve-card sm-hide__guteter">
          <div className="reserve-card__inner reserve-payment clearfix">
            {inner}
            <div className="reserve-payment__notes">
              {this.renderRequiredDescriptions()}
              <p className="reserve-payment__notes-text">「予約リクエスト」を送信し、ホストが内容を確認後「承認」すると予約成立となります。<br />予約完了までのご利用の流れは<a href={Routes.how_it_works_about_index_path()} className="a__underline" target="_blank">こちら</a>から確認いただけます。</p>
              {this.renderEstimateLink()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const room = this.state.room;

    let stepRows = [];
    if (this.state.plan) {
      stepRows.push(this.renderPriceType(room));
      if (this.state.isHourly != null) {
        stepRows.push(this.renderSelectSchedules(room));
        if (this.isStayPlan() && this.requestParams.stay_checkin_at && this.requestParams.stay_checkout_at) {
          stepRows.push(this.renderStayGuestInfo());
        } else if (this.isDayTimePlan() && this.isPerPersonPlan()) {
          stepRows.push(this.renderGuestInfo());
        }
        if (room.option_items.length > 0 || room.option_foods.length > 0) {
          stepRows.push(this.renderSelectOptions(room));
        }
      }
    }
    stepRows.push(this.renderResult(room));

    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              {this.renderSideBar(room)}
              <div>
                <div className="col-sm-12 col-md-8">
                  <form ref="form">
                    <input type="hidden" name="reserved_schedules[][is_session_start]" value={room.space.id} />
                    <h1 className="reserve-title">空き状況の確認／予約リクエスト</h1>
                    <fieldset>
                      <legend className="reserve-subtitle">プランを選択</legend>
                      <div className="reserve-card sm-hide__guteter">
                        {this.renderPlans(room)}
                      </div>
                    </fieldset>

                    <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                      {stepRows}
                    </CSSTransitionGroup>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.renderReservationRequest()}
        <SMUserContactView
          delegate={this}
          currentUser={this.props.currentUser}
          isOpen={this.state.isContactViewOpen} />
      </div>
    );
  }
}
export default SMReservationDesktopView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationDesktopView.jsx